import { DataProvider } from 'react-admin'
import { throwNotSupported } from '@/dataProvider'
import getVendorBatches from '../repository/getVendorBatches'
import Batch from '../types/Batch'

const physicalOrdersProvider: DataProvider = {
  getList: async (_resource, params) => {
    return await getVendorBatches(params).then((response) => {
      const total = response.total_entries
      const data = response.batches.map(parsePhysicalOrders)
      return { data, total }
    })
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

const parsePhysicalOrders = (batch: Batch) => {
  if (!batch) return null

  return {
    id: batch.id,
    date: batch.date,
    shipped: batch.shipped_items_count,
    open: batch.total_items_count,
    late: batch.late_items_count,
    refunds: batch.refunded_items_count,
    total:
      batch.total_items_count +
      batch.shipped_items_count +
      batch.refunded_items_count,
    lastDownloadedAt: batch.last_downloaded_at
  }
}

export default physicalOrdersProvider
